// src/pwa-listener.js
if (typeof window !== "undefined") {
  // place to store the event if it fires early
  window.__deferredPwaPrompt = null;

  window.addEventListener("beforeinstallprompt", (e) => {
    // prevent the automatic mini-infobar
    e.preventDefault();
    // store it so later code can use it
    window.__deferredPwaPrompt = e;
    // notify app that it's available
    window.dispatchEvent(new CustomEvent("pwa-deferred"));
  });

  window.addEventListener("appinstalled", () => {
    window.__deferredPwaPrompt = null;
    window.dispatchEvent(new CustomEvent("pwa-installed"));
  });
}
